import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { formatKey } from "../Common/FormatData/FormatData";
import PaymentDetails from "../PaymentDetails/PaymentDetails";
import { updateQuotesMedical } from "../../Redux/LogsRedux/Medical/MedicalQuotesRedux";

function Summary() {
  const location = useLocation();
  const { t } = useTranslation();
  const { planDetails } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { documentUploaded } = useSelector((state) => state.loading);

  const summaryDetails = {
    Full_Name: planDetails?.personalInformation?.personalInformation?.fullName,
    Email_ID: planDetails?.personalInformation?.personalInformation?.email,
    Mobile_Number:
      planDetails?.personalInformation?.personalInformation?.mobileNumber,
    Civil_ID_Number: planDetails?.personalInformation?.civil_id,
    Expiry_Date_of_Civil_ID:
      planDetails?.personalInformation?.personalInformation?.id_expiry_date,
    Residential_Location:
      planDetails?.personalInformation?.personalInformation?.resident_location,
    Nationality: planDetails?.personalInformation?.nationality,
  };

  const premiumDetails = {
    Basic_Premium: planDetails?.quoteDetails?.amount.base_price,
    Policy_Fee: planDetails?.quoteDetails?.amount.policy_fee,
    Government_Fee: planDetails?.quoteDetails?.amount.government_fee,
    Emergency_Fund_Fee: planDetails?.quoteDetails?.amount.emergency_fund_fee,
    Emergency_Fee_Visitor_Treatment:
      planDetails?.quoteDetails?.amount.emergency_fee_visitor_treatment,
    Emergency_Fee_Visitor_Treatment:
      planDetails?.quoteDetails?.amount.emergency_fee_visitor_treatment,
    Dhamani_Fee: planDetails?.quoteDetails?.amount.dhamani_fee,
    VAT: planDetails?.quoteDetails?.amount.vat,
    Total_Premium: planDetails?.quoteDetails?.amount.total,
  };

  const premiumQuotes = {
    quoteId: localStorage.getItem("MEDICAL_QUOTE_ID"),
    basePrice: planDetails?.quoteDetails?.amount.base_price,
    policyFee: planDetails?.quoteDetails?.amount.policy_fee,
    governmentFee: planDetails?.quoteDetails?.amount.government_fee,
    emergencyFundFee: planDetails?.quoteDetails?.amount.emergency_fund_fee,
    emergencyFeeVisitorTreatment:
      planDetails?.quoteDetails?.amount.emergency_fee_visitor_treatment,
    dhamaniFee: planDetails?.quoteDetails?.amount.dhamani_fee,
    vat: planDetails?.quoteDetails?.amount.vat,
    total: planDetails?.quoteDetails?.amount.total,
  };

  const handleSubmit = () => {
    dispatch(updateQuotesMedical(premiumQuotes)).then((result) => {
      if (result.success) {
        navigate("/payment-details", {
          state: { planDetails },
        });
      }
    });
  };

  const handleEdit = () => {
    navigate("/personal-information", {
      state: { planDetails },
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 py-3">
          <h3 className="title pt-2 mb-2">{t(planDetails?.coverPlan)}</h3>
          <h5 className="title subHeader p-0 fw-bold py-1 mb-0">
            {t("Summary")}
          </h5>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-lg-6 col-md-12">
          <div className="plan-card-plan shadow p-3">
            <div className="row plan-info mb-3">
              <div className="col-12">
                <h6 className="title p-0 fw-bold py-1 mb-2">
                  {t("Product Details")}
                </h6>
                <p className="plan-desc"></p>
                <div className="row mb-2">
                  <div className="col-12">
                    <p className="plan-desc mb-0">{t("Product")}</p>
                    <label className="section-label fw-bold">
                      {t(planDetails?.coverPlan)}
                    </label>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6 col-12 mb-2">
                    <p className="plan-desc mb-0">{t("Annual Limit")}</p>
                    <label className="section-label fw-bold">
                      {t(planDetails?.selectedLimit?.annualLimit || "-")}
                    </label>
                  </div>
                  <div className="col-md-6 col-12 mb-2">
                    <p className="plan-desc mb-0">
                      {planDetails?.coverPlan === "Individual Medical"
                        ? t("Selected Plan")
                        : t("Selected Plan Amount")}
                    </p>

                    <label className="section-label fw-bold">
                      {t(
                        planDetails?.selectedLimit?.planName ||
                          planDetails?.selectedLimit?.selectedPlanAmount ||
                          "-",
                      )}
                    </label>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6 col-12 mb-2">
                    <p className="plan-desc mb-0">{planDetails?.coverPlan === "Individual Medical"
                        ? t("OP Deductable")
                        : t("Out Patient Coverage")}</p>
                    <label className="section-label fw-bold">
                      {planDetails?.selectedLimit?.opDetectable > 0
                        ? planDetails?.selectedLimit?.opDetectable
                        : planDetails?.selectedLimit?.outPatientCoverage}
                    </label>
                  </div>
                    <div className="col-md-6 col-12 mb-2">
                    <p className="plan-desc mb-0">
                      {" "}
                      {planDetails?.coverPlan === "Individual Medical"
                        ? t("Co Pay")
                        : t("In Patient Coverage")}
                    </p>
                    <label className="section-label fw-bold">
                      {planDetails?.selectedLimit?.coPay > 0
                        ? planDetails?.selectedLimit?.coPay
                        : planDetails?.selectedLimit?.inPatientCoverage}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="plan-card-plan shadow p-3 mt-4">
            <div className="row plan-info mb-3">
              <div className="col-12">
                <h6 className="title p-0 fw-bold py-1 mb-1">
                  {t("Personal Details")}
                </h6>
                {Object.entries(summaryDetails).map(([key, value]) => (
                  <div
                    key={key}
                    className="d-flex align-items-center justify-content-between mb-2"
                  >
                    <p className="plan-desc me-2 mb-0">{t(formatKey(key))}:</p>
                    <label className="section-label fw-bold">
                      {value ?? "â€”"}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-6 col-md-12">
          <div className="plan-card-plan h-100">
            <div className="row plan-info mb-3">
              <div className="col-12">
                <h6 className="title p-0 fw-bold py-1">{t("Premium Details")}</h6>
                <table className="table table-bordered">
                  <tbody>
                    {Object.entries(premiumDetails).map(([key, value]) => (
                      <tr key={key}>
                        <td className="plan-desc w-75">
                          {formatKey ? t(formatKey(key)) : key}
                        </td>
                        <td className="section-label fw-bold w-25 text-end">
                          {value !== null && value !== undefined
                            ? Number(value).toFixed(2)
                            : "—"}{" "}
                          OMR
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

        <PaymentDetails
          planDetails={planDetails}
          quoteDetails={premiumQuotes}
          embedded
        />

        {/* <div className="col-lg-6 col-md-12">
          <div className="plan-card-plan shadow p-3">
            <div className="row plan-info mb-3">
              <div className="col-12">
                <h6 className="title p-0 fw-bold py-1 mb-0">
                  {t("Personal Details")}
                </h6>
                {Object.entries(summaryDetails).map(([key, value]) => (
                  <div key={key} className="d-flex align-items-center justify-content-between mb-2">
                    <p className="plan-desc me-2 mb-0">{t(formatKey(key))}:</p>
                    <label className="section-label fw-bold">
                      {value ?? "—"}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <div className="row mt-4 mb-2">
        <div className="col-12 text-start">
          <button
            type="button"
            onClick={handleEdit}
            className="btn btn-primary"
          >
            {t("Edit")}
          </button>
        </div>
      </div>
    </>
  );
}

export default Summary;
